'use client';

import { useEffect } from 'react';
import { assetsCdnUrl } from '~/constants/environment';
import { logError } from '~/utilities/loggers';
import webWorker from './webWorker';

const functionToURL = (fn: () => void) => {
  const blob = new Blob([`(${fn.toString()})()`], { type: 'text/javascript' });

  return URL.createObjectURL(blob);
};

const WarmVDPCache = () => {
  useEffect(() => {
    if (!window.Worker) return;

    let worker: Worker | null = null;

    try {
      const url = functionToURL(webWorker);
      worker = new Worker(url);

      worker.onerror = e => {
        console.log('Web Worker failed:', e.message);
        logError(e, {
          location: 'Warm VDP Cache - Web Worker runtime error'
        });
      };

      worker.postMessage({ CVNA_APP_CDN_URL: assetsCdnUrl });
    } catch (e) {
      console.log('Web Worker instantiation failed: ', e);
      logError(e, {
        location: 'Warm VDP Cache - Web Worker instantiation failed'
      });
    }

    return () => {
      worker?.terminate();
    };
  }, []);

  return null;
};

export default WarmVDPCache;
